import React from "react"; 
import "../../styles/whychoose.scss";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow
} from "@material-ui/core";

function BbysTable(props) {
  const secondary = props?.partner?.secondary_color || "#83C547"; // green
  const primary = props?.partner?.primary_color || "#2A83C2";
  const formatToK = (value) => {
    const num = Number(value.toString().replace(/,/g, ""));
    if (num < 1000) return num.toString();
    return `${num / 1000}k`.replace(/\.0k$/, "k");
  };
  // const Check = () => (
  //   <span style={{ fontSize: 28, color: "#22C55E" }}>&#10003;</span>
  // );
  const Check = () => (
  <span
    style={{
      width: 28,
      height: 28,
      background: "#FFFFFF",
      borderRadius: 4,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#22C55E"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  </span>
);


  const Cross = () => (
    <span style={{ fontSize: 32, color: "#D9534F" }}> &times;</span>
  );
  const isTLS = window.location.pathname.includes("/tls") || window.location.pathname.includes("/averra");

  const rows = [
    {
      label: "Buy Before You Sell",
      option1: <Check />,
      option2: <Check />
    },
    {
      label: "Remove Home Sale Contingency",
      option1: <Check />,
      option2: <Check />
    },
    {
      label: "Ability to Unlock Equity*",
      option1: <Cross />,
      option2: <Check />
    },
    {
      label: "Offer Turnaround Time",
      option1: "1–2 business days",
      option2: "5–9 business days"
    },
    {
      label: "Guaranteed Backup Agreement (GBA) Amount",
      option1: <>Minimum amount to clear existing mortgage balance</>,
      option2: <>Varies depending on the equity unlock needed</>
    },
    {
      label: "Fee Structure",
      option1: (
        <>
          {isTLS ? (
            <>
              $2k Admin Fee + 1% of the Guaranteed Backup Agreement
            </>
          ) : (
            <>
              $
              {formatToK(
                props.partner.administrative_fees
              )}{" "}
              + {props.partner.calque_percentage_fee}% of the Guaranteed Backup Agreement (GBA)
              <br />
              <span style={{ color: "#777", fontSize: 14 }}>
                (Lower Guaranteed Backup Agreements = Lower Fees)
              </span>
            </>
          )}
        </>
      ),
      option2: (
        <>
          {isTLS
            ? "2.4% of the final sales price of the departing residence"
            : `$${formatToK(
                props.partner.administrative_fees
              )} + ${props.partner.calque_percentage_fee}% of the Guaranteed Backup Agreement`}
        </>
      )
    },
    {
      label: "Calque Resale Guarantee",
      option1: <Check />,
      option2: <Check />
    }
  ];

  return (
    <div className="bbys-table-main-container inter">
      <div style={{ textAlign: "center" }}>
        <h2 className="new-heading">
          <span style={{ color: secondary }}>Two Great Ways {" "}</span>
          <span > to Buy Before You Sell</span>
        </h2>
        <h3
          className="new-sub-main-heading"
          style={{ textDecoration: "none", color: "#9A9A9A" }}
        >
          Pick the solution that's right for you
        </h3>
      </div>

      {/* TABLE */}
      <div className="bbys-table-container">
        <div className="bbys-table-scroll">
        <TableContainer
          style={{
            borderRadius: 12,
            overflow: "hidden",
            overflowX:"auto",
            marginTop: 20,
            boxShadow: "0 3px 10px rgba(0,0,0,0.08)"
          }}
        >
          <Table
            style={{
              borderCollapse: "separate",
              width: "100%"
            }}
          >
            {/* HEADER */}
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: "#E8F0FF",
                    border: "none",
                    fontWeight: 600,
                    textAlign: "left",
                    padding: "20px",
                    fontSize: 18
                  }}
                >
                  {/* empty left col */}
                </TableCell>

                <TableCell
                  align="center"
                  style={{
                    backgroundColor: "#E8F0FF",
                    fontWeight: 700,
                    fontSize: 20,
                    borderLeft: "1px solid #C7D8ED",
                    padding: "20px"
                  }}
                >
                  {window.location.pathname.includes("/tls")  || window.location.pathname.includes("/averra")
                    ? "Bring Your Own Cash+"
                    : "Contingency Buster"}
                </TableCell>

                <TableCell
                  align="center"
                  style={{
                    backgroundColor: primary,
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 20,
                    padding: "20px",
                    borderLeft: "1px solid #C7D8ED"
                  }}
                >
                  {window.location.pathname.includes("/tls")  || window.location.pathname.includes("/averra") ? (
                    "Buy Before You Sell+"
                  ) : (
                    <>{props?.partner?.partner_program_name}</>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>

            {/* BODY ROWS */}
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  {/* Left Label */}
                  <TableCell
                    style={{
                      fontWeight: 600,
                      padding: "18px 20px",
                      fontSize: 17,
                      borderBottom: "1px solid #E2E8F0",
                      background: "#fff"
                    }}
                  >
                    {row.label}
                  </TableCell>

                  {/* Option 1 */}
                  <TableCell
                    align="left"
                    style={{
                      padding: "18px 20px 18px 0px",
                      borderBottom: "1px solid #E2E8F0",
                      color: "#555",
                      fontSize: 16
                    }}
                  >
                    {row.option1}
                  </TableCell>

                  {/* Option 2 */}
                  <TableCell
                    align="left"
                    style={{
                      padding: "18px 20px 18px 0px",
                      borderBottom: "1px solid #E2E8F0",
                      color: "#555",
                      fontSize: 16
                    }}
                  >
                    {row.option2}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </div>
      </div>
      {window.location.pathname.includes("/tls")  || window.location.pathname.includes("/averra") ? (
        <span
          style={{
            color: "black",
            fontStyle: "italic",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "15px",
            marginTop: "-10px",
            textAlign: "center",
          }}
        >
          *Additional fees may apply, particularly in counties with specific regulatory
          or title requirements. For more details, refer to Calque's Guaranteed Backup
          Agreement.
        </span>
      ) : (
        <p className="Footer-Notes">
          *Calque is not a lender and does not provide loan funding. If borrowers need to
          access their home’s equity, their loan officer will arrange a second mortgage.
          Any associated fees are processed by the originating lender.
        </p>
      )}

      {/* FOOTER BANNER */}
      <div
        className="bbys-text-container"
        style={{
          backgroundColor: primary,
          marginTop: 25,
          padding: "20px 30px",
          display: "flex",
          gap: 20,
          borderRadius: 12,
          alignItems: "center",
          color: "#fff"
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" className="svg-icon">
          <path d="M25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM25 45C13.975 45 5 36.025 5 25C5 13.975 13.975 5 25 5C36.025 5 45 13.975 45 25C45 36.025 36.025 45 25 45ZM36.475 13.95L20 30.425L13.525 23.975L10 27.5L20 37.5L40 17.5L36.475 13.95Z" fill={"#ffffffff"} />{/*#83C547*/}
        </svg>
        <p style={{ fontSize: 18, margin: 0 }}>
          Net Profit Return: If Calque purchases your home and resells it for more than the Guaranteed Backup Agreement, we’ll refund the net profit after expenses, including but not limited to the purchase price, commissions, interest, taxes, title and other applicable fees.
        </p>
      </div>
    </div>
  );
}

export default BbysTable;

